/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wehavesentaverificationemailto6Inputs */

const en_wehavesentaverificationemailto6 = /** @type {(inputs: Wehavesentaverificationemailto6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We have sent a verification email to`)
};

const de_wehavesentaverificationemailto6 = /** @type {(inputs: Wehavesentaverificationemailto6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben die Bestätigungs-E-Mail geschickt an`)
};

/**
* | output |
* | --- |
* | "We have sent a verification email to" |
*
* @param {Wehavesentaverificationemailto6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const wehavesentaverificationemailto6 = /** @type {((inputs?: Wehavesentaverificationemailto6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wehavesentaverificationemailto6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wehavesentaverificationemailto6(inputs)
	return de_wehavesentaverificationemailto6(inputs)
});
export { wehavesentaverificationemailto6 as "weHaveSentAVerificationEmailTo" }